<div class="ion-margin-start">
  <h1>Piano di Cura Base</h1>

  <ion-note>
    Configura il piano di cura di base per il paziente dalle sezioni disponibili qua sotto
  </ion-note>
</div>

<ion-grid class="ion-margin-top" *ngIf="!currentShownConfigs">
  <ion-row>
    <ion-col class="c3-flex ion-align-items-center ion-justify-content-center">
      <ion-icon size="large" color="secondary" [src]="'information-outline' | getIcon"> </ion-icon>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col class="c3-flex ion-align-items-center ion-justify-content-center">
      <p>In questa sezione non è presente alcuna configurazione disponibile</p>
    </ion-col>
  </ion-row>
</ion-grid>

<ion-grid class="ion-margin-top">
  <ion-row>
    <ion-col size="12" *ngIf="showConfig('icd9')" id="anchor-icd9">
      <c3-config-icd9 #configSection>
      </c3-config-icd9>
    </ion-col>

    <ion-col size="12" *ngIf="context == 'chirugia'" id="anchor-operations">
      <c3-config-operations #configSection />
    </ion-col>

    <ion-col size="12" *ngIf="showConfig('therapies')" id="anchor-therapies">
      <c3-config-therapies #configSection [context]="patientContext$ | async">
      </c3-config-therapies>
    </ion-col>

    <ion-col size="12" *ngIf="showConfig('exams')" id="anchor-exams">
      <c3-config-examinations #configSection></c3-config-examinations>
    </ion-col>

    <ion-col size="12" *ngIf="showConfig('tasks')" id="anchor-task">
      <c3-config-tasks #configSection [context]="patientContext$ | async"> </c3-config-tasks>
    </ion-col>

    <!-- <ion-col size="12" *ngIf="showConfig('diet')" id="anchor-diet">
      <c3-config-diet #configSection [context]="patientContext$ | async"> </c3-config-diet>
    </ion-col> -->

    <ion-col size="12" *ngIf="showConfig('physical-activity')" id="anchor-physical-activity">
      <c3-config-physical-activity #configSection> </c3-config-physical-activity>
    </ion-col>

    <ion-col size="12" *ngIf="showConfig('glycaemia-profile')" id="anchor-glycaemia-profile">
      <c3-config-glycaemia-profile #configSection [glycaemiaProfile]="glycaemiaProfile"> </c3-config-glycaemia-profile>
    </ion-col>
  </ion-row>
</ion-grid>